import { setLocaleObjectNamespace } from "../../../common/src/setLocaleObjectNamespace";

export default setLocaleObjectNamespace("reminders", {
    confirmSendReminder: "Отправить рассылку сейчас",
    successSubmitReminder: "Рассылка будет обработана в ближайшее время",
    broadcast: "Трансляция",
    mailing: "Рассылка",
    editing: "Редактирование",
    mailSubject: "Тема письма",
    availableValues: "Доступные значения",
    mailingType: "Тип рассылки",
    autoMailingType: "автоматическая",
    manualMailingType: "добавлена вручную",
    mailTemplate: "Шаблон письма",
    mailingMethod: "Способ рассылки",
    mailingDatetime: "Дата и время отправки",
    mailingTime: "Время отправки",
    addRecipients: "Добавить получателей",
    watch: "Смотреть",
    save: "Сохранить",
    back: "Назад",
    emailError: "Неверный формат email",
    recipients: "Получатели",
    participationFormat: "Формат участия",
    additionalCriterion: "Доп. критерий для рассылки",
    additionalCriterionCondition: `Пользователь посмотрел не менее, чем <b>X</b> и
    не более, чем <b>Y</b> от общей продолжительности.`,
    additionalCriterionMeashure: "Выберите меру исчисления для X и Y",
    set: "Задать",
    uploadEmailsFromExcel: "Загрузить участников из excel",
    email: "Почта",
    add: "Добавить",
    close: "Закрыть",
    sheetInfo: `Выберите столбец и номер первой строки содержащие необходимые
    адреса электронной почты.`,
    sheet: "Лист",
    column: "Столбец",
    firstRowNumber: "Номер первой строки",
    apply: "Применить",
    forTicketHolders: "Для владельцев билетов",
    addMailing: "Добавить рассылку",
    recepientSource: "Источник получателей",
    templateTitle: "Название шаблона",
    status: "Статус",
    actions: "Действия",
    edit: "Править",
    sendNow: "Отправить сейчас",
    remove: "Удалить",
    application: "Заявка",
    refusal: "Отказ",
    viewer: "Зритель",
    moderator: "Модератор",
    formatAll: "Всем по умолчанию",
    online: "Онлайн",
    offline: "Офлайн",
    registeredType: "Для зарегистрированных",
    customType: "Заданный список",
    registeredSource: "Регистрация",
    watchedSource: "Зрители",
    customSource: "Заданный список",
    ticketSource: "Владельцы билетов",
    statusWaiting: "Ожидает",
    statusProgress: "В работе",
    statusError: "Ошибка",
    statusDone: "Завершено",
    manualMailingMethod: "Вручную",
    timeMailingMethod: "В заданное время",
    everydayMailingMethod: "Периодическая",
    viewTypeBroadcast: "Во всей трансляции",
    viewTypeHall: "В конкретном зале",
    viewTypeEpisode: "В конкретном эпизоде",
    meashureTypeMinutes: "минуты",
    noCustomTemplatesFound: "Пользовательских шаблонов не найдено",
    setMailSubject: "Укажите тему письма",
    useAdditionalCriterion: "Использовать доп. критерии",
    removeReminder: "Удалить рассылку",
    no: "Нет",
    yes: "Да",
    statistics: "Статистика",
    generatedReminder: "Сформированная рассылка",
    role: "Роль",
    whenToSend: "Когда отправлять",
    setTemplate: "Укажите шаблон",
    setReminderSubject: "Укажите тему рассылки",
    setTemplateAndTopic: "Выберите шаблон и тему рассылки",
    choose: "Выбрать",
    cancel: "Отмена",
    periodicSendStartDate: "Дата и время начала периода",
    periodicSendEndDate: "Дата и время конца периода",
    optional: "опционально",
    setViewingType: "Установить тип просмотра",
    statisticSourse: "Зрители из статистики",
    letterType: "Тип письма",
    systemicReminder: "Системное",
    customReminder: "Кастомное",
    listOfRecipients: "Список получателей",
    sent: "Отправлено",
    notSent: "Ошибка отправки",
    inQueue: "В очереди",
    recipientsStatuses: `
        <b>Отправлено:</b><br />
        Означает, что письмо было успешно передано на SMTP сервер и находится в процессе дальнейшей обработки.
        Это не гарантирует, что письмо было успешно доставлено конечному получателю.<br />
        <b>Ошибка отправки:</b><br />
        Может использоваться для обозначения ситуации, когда SMTP сервер отклонил письмо из-за проблем с настройками, аутентификацией или другими причинами.<br />
        <b>В очереди:</b><br />
        Показывает, что письмо поставлено в очередь на отправку и еще не доставлено на SMTP сервер.
        Этот статус может означать, что система ожидает отправку письма, и его фактическая доставка будет произведена в ближайшее время.<br />
    `,
});
